import { render } from "./birthday-list-modal.vue?vue&type=template&id=d34c4c24"
import script from "./birthday-list-modal.vue?vue&type=script&lang=js"
export * from "./birthday-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__